/** @jsx h */
import { h, Component, JSX } from 'preact';
import cssStyles from './arrow-button.css';

interface ArrowProps {
  size: number;
  color: string;
}

export default class Arrow extends Component<ArrowProps> {
  render(): JSX.Element {
    const { size, color } = this.props;
    const arrowWidth = size / 1.61;
    const arrowHeight = size;

    const arrowStyle = { color };

    return (
      <span style={arrowStyle} className={cssStyles.arrow}>
        <svg
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          width={arrowWidth}
          height={arrowHeight}
          viewBox="0 0 318 512"
        >
          <path d="M319.1 217c20.2 20.2 19.9 53.2-.6 73.7s-53.5 20.8-73.7.6l-190-190c-20.1-20.2-19.8-53.2.7-73.7S109 6.8 129.1 27l190 190z" />
          <path d="M319.1 290.5c20.2-20.2 19.9-53.2-.6-73.7s-53.5-20.8-73.7-.6l-190 190c-20.2 20.2-19.9 53.2.6 73.7s53.5 20.8 73.7.6l190-190z" />
        </svg>
      </span>
    );
  }
}
